import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


const drawer = ref(false);


return { __sfc: true,drawer }
}

})